<template>
  <div>
    
    <CModal v-if="show"
      :show.sync="show"
      :backdrop="backdrop"
      :closeOnBackdrop="closeOnBackdrop"
      :centered="centered"
      :size="size"
      :color="color"
    >
      <template #header-wrapper>
        <div class="d-flex justify-content-center popup-icon ">
          <!-- <div class=""> -->
          <template>
            <CCardHeader>
              <!-- <CRow></CRow> -->
              <CRow>
                <img
                  class="success-popup-icon icon-wobble-ani"
                  src="@imgPath/img/svg/icons/down-stright-arros.svg"
                />
                <!-- <CIcon color="white" name="cil-check" size="lg" /> -->
              </CRow>
            </CCardHeader>
          </template>
          <br />
          <br />
          <!-- </div> -->
        </div>
      </template>

      <br />
      <br />
      <CCardBody>

      
      <div class="d-flex justify-content-center alert-msg">
        <strong   style="text-align: center" class="pre-formatted ">
        {{$t('jsonExcelModal.download')}}
        </strong>
    
        <p>{{ desc }}</p>
  
      </div>
      </CCardBody>
      <template #footer-wrapper>
        <CCardBody class="d-flex justify-center">
          <CRow>
            <CButton @click="onCancel" class="btn btn action-c-btn btn-cancel m-auto curve-border mr-15px">
              {{$t('jsonExcelModal.cancel')}}
            </CButton>
            <div>
              <!-- <CButton  @click="callExportData()" class="btn btn action-c-btn btn-success m-auto curve-border "> -->
                <slot name="jsonExcel"></slot>
              <!-- </CButton> -->

            </div>
<!--            <CCol style="background-color: blue;-->
<!--              color: white">-->
<!--              <slot name="jsonExcel"></slot>-->
<!--            </CCol>-->
          </CRow>
        </CCardBody>
      </template>
    </CModal>
  </div>
</template>

<script>
export default {
  name: "cJsonExcelModal",
  props: {
    show: {
      type: Boolean,
      default: false
    },

    backdrop: {
      type: Boolean,
      default: true
    },

    closeOnBackdrop: {
      type: Boolean,
      default: false
    },
    centered: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "sm"
    },
   onCancel:{
            type:Function,
            default:null
   },
    color: {
      type: String,
      default: "dark"
    },
    nextLine: {
      type: String,
      default: ""
    },
    desc: {
      type: String,
      default: ""
    }
  },

  methods: {
    // callExportData(){
    //           this.$root.$emit('callExport',true);
    //         },
  }


 


 
 


  
};
</script>
<style scoped></style>
